import React, { useEffect, useState, useMemo } from 'react';

import PropTypes from 'prop-types';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { getAllStorageValues } from '../../utils/session-storage';
import { replaceRichTextTags } from '../../utils/contenful-richText-replacement';
import { Wrapper } from './styles';
import { RichTextPropTypes } from '../../prop-types';
import RenderNode from './render-node';

/**
 * The basic RTE can be called without an assembly for
 * components that do not wish to use embedded entries
 */
const RichTextBase = ({
  richText,
  className,
  backgroundColor,
  padding,
  textRenderer,
  linkData,
  assembly,
  noWrapper,
}) => {
  const [richTextData, setRichTextData] = useState(richText);
  const replacements = useMemo(
    () => getAllStorageValues('rich_text_replacements'),
    []
  );

  useEffect(() => {
    setRichTextData(richText);
  }, [richText]);

  useEffect(() => {
    const tags = Object.keys(replacements);
    // bail early if no replacements
    if (tags.length === 0) return;

    setRichTextData((prev) => {
      const newRichText = { ...prev };

      // Edit the RichText Message when opt for Yes Gift Aid -> add tag to session storage
      tags.forEach((tag) =>
        replaceRichTextTags(newRichText, [
          {
            tag: `{{${tag}}}`,
            replacement: replacements[tag],
          },
        ])
      );

      return newRichText;
    });
  }, [replacements]);

  // Render null until the data is ready

  if (!richText) return null;

  if (richText.references) {
    richText.references = richText.references.filter(Boolean);
  }

  if (noWrapper) {
    return renderRichText(
      richTextData,
      RenderNode(linkData, assembly, textRenderer)
    );
  }
  return (
    <Wrapper
      $backgroundColor={backgroundColor}
      $padding={padding}
      className={className}
    >
      {renderRichText(
        richTextData,
        RenderNode(linkData, assembly, textRenderer)
      )}
    </Wrapper>
  );
};

/**
 * 'default' prop type is used when no selection in Contentful is made
 */
RichTextBase.propTypes = {
  richText: RichTextPropTypes,
  className: PropTypes.string,
  textRenderer: PropTypes.func,
  backgroundColor: PropTypes.oneOf(['default', 'white', 'grey']),
  padding: PropTypes.bool,
  linkData: PropTypes.object,
  assembly: PropTypes.elementType,
  noWrapper: PropTypes.bool,
};

RichTextBase.defaultProps = {
  backgroundColor: 'white',
  noWrapper: false,
};

export default RichTextBase;
